export const products = [
  {
    id: 0,
    title: "CryptoCoin - Crypto Price Tracker",
    link: "https://cryptocc.vercel.app",
    site: "https://cryptocc.vercel.app",
    desc: "CryptoCoin is a platform providing real-time cryptocurrency market data, including prices, trends, and trading volumes. It features tools for tracking and analyzing the performance of various digital currencies. The site aims to help users make informed investment decisions in the crypto market. ",
    tech1: "NextJs, Tailwind, Firebase Auth,Firestore, Recharts",
    img: "./assets/cryptocc.png",
    color: "#c1121f",
  },

  {
    id: 1,
    title: "Fomonerd - Blog Site",
    link: "https://fomonerd.com/",
    site: "https://fomonerd.com/",
    desc: "FomoNerd is a platform designed to keep users updated with the latest in gaming, movies, anime, and pop culture. It provides reviews, news, and in-depth articles to help fans stay informed about trending topics and upcoming releases. The site aims to engage enthusiasts by offering insights and discussions on various entertainment subjects.",
    tech1: "NextJs, Material-Ui, Firebase",
    img: "./assets/fomonerd.png",
    color: "#2d6a4f",
  },
  {
    id: 1,
    title: "Bucket Swap - Solana Token Exchnage",
    link: "https://bucketswap.vercel.app",
    site: "https://bucketswap.vercel.app",
    desc: "This is a decentralized token-swapping platform built on the Solana blockchain. It provides users with a fast, efficient, and secure way to exchange cryptocurrencies, leveraging Solana's high-speed transaction capabilities and low fees. This platform aims to simplify the token swap experience within the decentralized finance (DeFi) ecosystem.",
    tech1: "NextJs, Tailwind, Solana , Web3.js , Jupiter Api",
    img: "./assets/bucketswap.png",
    color: "#99582a",
  },
  {
    id: 1,
    title: "NPM Package - Open Graph Data",
    link: "https://metadata-fetcher.vercel.app/ ",
    site: "https://metadata-fetcher.vercel.app/ ",
    desc: "NPM package designed to retrieve metadata from websites. It provides an easy-to-use interface for extracting key information like titles, descriptions, and images. Additionally, it is available as an npm package, allowing developers to integrate metadata-fetching functionality directly into their projects.",
    tech1: "NextJs, Tailwind, Cheerio",
    img: "./assets/metadata.png",
    color: "#003049",
  },
  {
    id: 1,
    title: "Future Diary - Sanity Blog Site",
    link: "https://futurediary.vercel.app/ ",
    site: "https://futurediary.vercel.app/ ",
    desc: "A blog platform built using Next.js, Tailwind CSS, and Sanity.io, with Framer Motion used for animations. It provides a smooth, interactive experience for users to create and manage blog posts, combining modern design with seamless animations to enhance user engagement.",
    tech1: "NextJs, Shadcn-Ui, Tailwind, Sanity.io, Framer Motion",
    img: "./assets/futureDiary.png",
    color: "#3c096c",
  },
];
